import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";
export const Home: FC<IconProps> = ({ color = defaultColor, height = 24 }) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1951 12.6872C19.992 12.8901 19.7472 12.9915 19.4607 12.9915C19.1743 12.9915 18.9321 12.8927 18.7342 12.695L18.4998 12.4608V19.001C18.4998 19.2716 18.4035 19.5057 18.2108 19.7034C18.0181 19.9011 17.7811 20 17.4999 20H14.5V15.5046C14.5 15.3693 14.4505 15.2523 14.3516 15.1534C14.2526 15.0545 14.1355 15.0051 14 15.0051H11.0002C10.8648 15.0051 10.7476 15.0545 10.6486 15.1534C10.5497 15.2523 10.5002 15.3693 10.5002 15.5046V20H7.50035C7.21911 20 6.98214 19.9011 6.78944 19.7034C6.59675 19.5057 6.5004 19.2716 6.5004 19.001V12.4608L6.26603 12.695C6.06812 12.8927 5.82595 12.9915 5.5395 12.9915C5.25306 12.9915 5.00828 12.8901 4.80516 12.6872C4.60205 12.4843 4.50049 12.2397 4.50049 11.9535C4.50049 11.6674 4.59944 11.4254 4.79735 11.2277L11.7345 4.29731C11.9429 4.08919 12.198 3.99034 12.5001 4.00074C12.8022 3.99034 13.0574 4.08919 13.2657 4.29731L20.2029 11.2277C20.4008 11.4254 20.4997 11.6674 20.4997 11.9535C20.4997 12.2397 20.3982 12.4843 20.1951 12.6872Z"
      fill={color}
    />
  </svg>
);
